export default __webpack_public_path__ + "static/media/video - lunar-volvelle.7196718e.mp4";